import React from 'react';
import { useI18n } from '../i18n';
import { Globe } from 'lucide-react';
import { componentScope } from '../lib/cssScope'
import { Select } from '@/components/ui/Select';

export type NationalProfile = 'EU' | 'ES' | 'CUSTOM';

const STORAGE_KEY = 'nationalProfile';

export function getStoredNationalProfile(): NationalProfile {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'ES' || v === 'EU' || v === 'CUSTOM') return v;
  } catch {}
  return 'EU';
}

export function setStoredNationalProfile(profile: NationalProfile): void {
  try {
    localStorage.setItem(STORAGE_KEY, profile);
  } catch {}
}

/** Standards activated by profile (UI-level, merged with org flags) */
export function getStandardsForProfile(profile: NationalProfile): string[] {
  switch (profile) {
    case 'ES':
      return ['ISO 27001', 'ENS'];
    case 'EU':
      return ['ISO 27001', 'NIS2'];
    case 'CUSTOM':
    default:
      return [];
  }
}

const NationalProfileSelector: React.FC<{
  value: NationalProfile;
  onChange: (p: NationalProfile) => void;
}> = ({ value, onChange }) => {
  const { t } = useI18n();

  return (
    <div className={`${componentScope('NationalProfileSelector')} flex items-center gap-2`} title={t('compliance.nationalProfile.hint', 'National compliance profile')}>
      <Globe className="h-4 w-4 shrink-0 text-gray-500" aria-hidden />
      <Select<NationalProfile>
        options={[
          { value: 'EU', label: t('compliance.nationalProfile.eu', 'EU (ISO27001 + NIS2)') },
          { value: 'ES', label: t('compliance.nationalProfile.es', 'ES (ISO27001 + ENS)') },
          { value: 'CUSTOM', label: t('compliance.nationalProfile.custom', 'Custom') },
        ]}
        value={value}
        onChange={(v) => {
          if (v != null) onChange(v)
        }}
        placeholder={t('compliance.nationalProfile.aria', 'National Profile')}
        minWidth="12rem"
      />
    </div>
  );
};

export default NationalProfileSelector;
